import axios from 'axios'
import { pathOr } from 'ramda'
import { CODE_PROMO_REQUEST, CODE_REQUEST } from '../../../../helpers/request'
import { IsDev } from '../../../../helpers/build'
import { asyncTimeout } from '../../../../helpers/utils'
import toggleGlobalLoader from '../../../loader/actions/loaderActions'
import codeApply from './codeChange'
import {
  SEARCH_PARAM_CLIENT_CODE,
  SEARCH_PARAM_CONTRACT_NUMBER,
  SEARCH_PARAM_PROMO_CODE,
} from '../../constants'

export default code => async (dispatch) => {
  try {
    dispatch(toggleGlobalLoader(true))
    if (IsDev) {
      await asyncTimeout(2)
    } else {

      const sendProffesional = code[SEARCH_PARAM_CLIENT_CODE] && code[SEARCH_PARAM_CLIENT_CODE].length > 1 ||
        code[SEARCH_PARAM_CONTRACT_NUMBER] && code[SEARCH_PARAM_CONTRACT_NUMBER].length > 1

      if ( sendProffesional ) {
        dispatch(codeApply('errorPromo', ''))
        dispatch(codeApply('wrongPromoCodeMessage', ''))
        dispatch(codeApply('wrongPromoCode', ''))
        await axios.post(CODE_REQUEST, code)
      }
      if (!sendProffesional && code[SEARCH_PARAM_PROMO_CODE].length > 1) {
        const promo = {
          promoCode: code.promoCode,
        }
        await axios.post(CODE_PROMO_REQUEST, promo)
      }
    }
  } catch (error) {
    dispatch(toggleGlobalLoader(false))
    throw pathOr('Your code is invalid. Please enter valid code.', ['response', 'data', 'errorMessage'], error)
  }

  return true
}
